import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';

import { useWizardStateContext } from '@/app/[locale]/product/_contexts/WizardStateProvider';
import WizStepId from '@/app/[locale]/product/_steps/enums/WizStepId';

const VariantLabel = ({
  inverseHeader,
}: {
  readonly inverseHeader: boolean | undefined;
}) => {
  const t = useTranslations();
  const { currentStep, currentRoute } = useWizardStateContext();
  const style = currentRoute.style;
  const finish = currentRoute.finish;
  const accessory = currentRoute.accessory;
  const isAccessory = accessory.isValid;

  const label = `wizard_image_label_${style.value}_${finish.value}`;

  if (
    currentStep === WizStepId.Style ||
    isAccessory ||
    currentRoute.isOuraRing4Wizard
  )
    return null;
  return (
    <div
      className={cx(
        'absolute bottom-4 left-4 z-10 text-inherit lg:static lg:mr-4 lg:text-xl',
        {
          'text-sandstone-100': inverseHeader,
        },
      )}
    >
      {t(label)}
    </div>
  );
};

export default VariantLabel;
